import React, { useState, useEffect } from 'react';
import * as _ser from '../../../../_redux/_services/ApplicantsSlice';
import DynamicTable from '../../../../components/DynamicTable/DynamicTable';

const JobpostingDetailsAuditlogging = ({ data }) => {
  const [AuditlogData, setAuditlogData] = useState([]);
  const [config, setConfig] = useState(configuration);

  useEffect(() => {
    if (data && data.length > 0) {
      setAuditlogData(data);
      let configObj = JSON.parse(JSON.stringify(config));
      configObj.totalRecords = data.length;
      setConfig(configObj);
    }
  }, [data]);

  const onReceiveActionHandler = (type, object) => {
    if (type === 'pageRange') {
      setConfig({
        ...config,
        limitData: (config.limitData = object),
        recordperPage: (config.limitData = object),
        currentPage: 1,
      });
    }
  };

  return (
    <>
      <div style={{ padding: '0 0px', marginBottom: '80px' }}>
        <div style={{ background: '#fff', padding: '25px 15px' }} id="auditLog">
          {AuditlogData === null ||
            (AuditlogData.length === 0 && (
              <DynamicTable
                config={config}
                data={AuditlogData}
                colmns={columnsData}
                actionDropdown={actionsDropdownData}
                actions={actionsList}
                filterValue={''}
                noDataText={'No Audit logs found'}
                addModel={addNewModel}
                searchKeyWord="Search by Actions"
                onReceiveActionProps={(type, obj) =>
                  onReceiveActionHandler(type, obj)
                }
              />
            ))}
          {AuditlogData && AuditlogData.length > 0 && (
            <DynamicTable
              config={config}
              data={AuditlogData}
              colmns={columnsData}
              actionDropdown={actionsDropdownData}
              actions={actionsList}
              filterValue={''}
              noDataText={'No Audit logs found'}
              addModel={addNewModel}
              searchKeyWord="Search by Actions"
              onReceiveActionProps={(type, obj) =>
                onReceiveActionHandler(type, obj)
              }
            />
          )}
        </div>
      </div>
    </>
  );
};

export default JobpostingDetailsAuditlogging;

// for dynamic Table config Object
const configuration = {
  isSearchbar: false,
  isPaging: true,
  isDropdownActions: false,
  isCheckbox: false,
  isActions: false,
  recordperPage: 10,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: false,
  totalRecordsCount: 0,
  totalRecordsCountText: '',
  limitData: 10,
  isCheckAlignRight: false,
  isPaginationTop: false,
  isSearchServer: false,
  isPagingServer: false,
  isPageRange: true,
};

// for dynamic Table Action dropdownData
const actionsDropdownData = ['Delete'];

// for dynamic Table row Action buttons
const actionsList = {
  isDownload: false,
  isDelete: false,
};

// for dynamic Table Headers and columns
const columnsData = [
  {
    id: 1,
    displayName: 'Action Performed',
    mappingName: 'action',
    theadClass: 'dynatableheadtext text-center',
    tbodyClass: 'dynatablebodytext text-center NameCapitalise',
    width: '20%',
    isEdit: false,
    nagigate: '',
  },
  {
    id: 2,
    displayName: 'Performed By',
    mappingName: 'fullName',
    theadClass: 'dynatableheadtext text-center',
    tbodyClass: 'dynatablebodytext text-center',
    width: '15%',
    isEdit: false,
    nagigate: '',
  },
  {
    id: 3,
    displayName: 'Date and Time',
    mappingName: 'createdAt',
    theadClass: 'dynatableheadtext text-center ',
    tbodyClass: 'dynatablebodytext text-center',
    width: '15%',
    isEdit: false,
    nagigate: '',
  },
  {
    id: 4,
    displayName: 'Comments',
    mappingName: 'comments',
    theadClass: 'dynatableheadtext text-center',
    tbodyClass: 'dynatablebodytext text-center',
    width: '50%',
    isEdit: false,
    nagigate: '',
  },
];

const addNewModel = {
  url: '',
  displayName: '',
};
